__webpack_require__.v = function(exports, wasmModuleId, wasmModuleHash, importsObj) {
	var req = fetch(__webpack_require__.p + "" + wasmModuleHash + ".module.wasm");
	if (typeof WebAssembly.instantiateStreaming === 'function') {
		return WebAssembly.instantiateStreaming(req, importsObj)
			.then(function(res) { return Object.assign(exports, res.instance.exports); });
	}
	return req
		.then(function(x) { return x.arrayBuffer(); })
		.then(function(bytes) { return WebAssembly.instantiate(bytes, importsObj); })
		.then(function(res) { return Object.assign(exports, res.instance.exports); });
};